import App, { AppProps } from 'next/app';
import React from 'react';
import Router from 'next/router';
import NProgress from 'nprogress';
import '~style/style.scss';
import GlobalStyles from '~components/GlobalStyle';
import HeadComponent from '~components/HeadComponent';

require('slick-carousel/slick/slick.scss');
require('slick-carousel/slick/slick-theme.scss');

Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

export const PageContext = React.createContext({
  isEditMode: false,
  asPath: '',
});

function MyApp(appProps: AppProps) {
  const {
    Component,
    router: {
      query: { dotcmsStatus },
      asPath,
    },
    pageProps,
  } = appProps;

  const { error } = pageProps;
  const isEditMode = pageProps.hasOwnProperty('viewAs')
    ? pageProps.viewAs.mode === 'EDIT_MODE'
    : false;

  const FinalComponentToRender = () =>
    error ? <Component {...error} /> : <Component {...pageProps} />;

  return (
    <PageContext.Provider
      value={{
        isEditMode,
        asPath,
      }}
    >
      <HeadComponent {...(pageProps.pageRender ? pageProps.pageRender.page : {}) } />
      <GlobalStyles>
        <FinalComponentToRender />
      </GlobalStyles>
    </PageContext.Provider>
  );
}

MyApp.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext);
  return { ...appProps };
};

export default MyApp;
